export const PhoneMask = (phone) => {
    if(!phone) return phone
    return phone.length < 11
        ? phone.replace(/^(\d{2})(\d{4})(\d{4})./, '($1) $2-$3')
        : phone.replace(/^(\d{2})(\d{5})(\d{4})./, '($1) $2-$3');
}


export const RemoveMask = (phone) => phone.replaceAll(/[^0-9.]/g, '');

/**
 * Formata telefone de 10 (fixo) ou 11 (celular) dígitos, devolvendo '-' quando
 * o valor não vier ou não tiver tamanho válido.
 *
 * Diferente de `PhoneMask`, cobre o fixo de 10 dígitos e aceita valores que já
 * cheguem mascarados do backend.
 */
export const formatPhone = (phone) => {
    if (!phone) return '-'

    const digits = String(phone).replace(/[^0-9]/g, '')

    if (digits.length === 11) return `(${digits.slice(0, 2)}) ${digits.slice(2, 7)}-${digits.slice(7)}`
    if (digits.length === 10) return `(${digits.slice(0, 2)}) ${digits.slice(2, 6)}-${digits.slice(6)}`

    return '-'
}
